import React, { useState } from 'react';
import ReactSelect from 'react-select';
import classnames from 'classnames';
import { compact } from 'lodash';

import Button from '../../Button/Button';
import { customStyles, LevelOptionType } from './customStyles';
import { EnglishLevelsFragment } from '../../../../graphql.schema';
import { RichTextField } from '../../RichTextField/RichTextField';

import * as styles from './strapi-levels.module.scss';

export const StrapiLevelsComponent = ({
  heading,
  description,
  footerHeader,
  footerDescription,
  footerLinkUrl,
  footerLinkUrlText,
  englishLevels,
}: EnglishLevelsFragment) => {
  const mappedValues = englishLevels?.map((item) => ({ ...item, value: item?.level, label: item?.level }));
  const [selectedLevel, setSelectedLevel] = useState<LevelOptionType>(mappedValues![0]);

  const handleDropdownChange = (value: any) => {
    setSelectedLevel(value);
  };

  return (
    <div className={classnames(styles.root)}>
      <div className="columns">
        <div className="column is-6 is-offset-2">
          <h2 className="title is-2 brand-a">{heading}</h2>
          <RichTextField content={`<p class="is-text-2 black-2">${description}</p>`} />
        </div>
      </div>
      <div className="columns">
        <div className="column is-8 is-offset-2">
          <div className={classnames(styles.levels, 'is-hidden-mobile')}>
            {compact(mappedValues).map((level) => (
              <div
                className={classnames({
                  [`${styles.selectedBackgroundWrapper} has-bg-brand-a`]: selectedLevel?.level === level.level,
                })}
                key={level.level}
              >
                <div
                  onClick={() => setSelectedLevel(level)}
                  className={classnames({
                    [`has-bg-brand-a ${styles.selectedLevel}`]: selectedLevel?.level === level.level,
                    [styles.levelWrapper]: selectedLevel?.level !== level.level,
                  })}
                >
                  <h3 className={classnames(styles.level, 'title is-3')}>{level?.level}</h3>
                </div>
              </div>
            ))}
          </div>
          <div className="is-hidden-tablet">
            <ReactSelect
              styles={customStyles}
              components={{ IndicatorSeparator: () => null }}
              onChange={(val) => handleDropdownChange(val)}
              options={mappedValues}
              value={selectedLevel}
            />
          </div>
          <RichTextField className={styles.levelDescription} content={selectedLevel?.levelDescription} />
        </div>
      </div>

      {footerHeader && (
        <div className="columns">
          <div className="column is-6 is-offset-2">
            <h3 className="title is-3 brand-a">{footerHeader}</h3>
            <RichTextField content={`<p class="is-text-2 black-2 mb-5">${footerDescription}</p>`} />
            <div className="">
              <Button type="secondary" href={footerLinkUrl ?? ''} className="is-inline-flex is-text-2 link-spacing">
                {footerLinkUrlText}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
